import { render, staticRenderFns } from "./DistributionListEdit.vue?vue&type=template&id=0466e2d4&scoped=true&"
import script from "./DistributionListEdit.vue?vue&type=script&lang=js&"
export * from "./DistributionListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0466e2d4",
  null
  
)

export default component.exports